/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  const header = document.querySelector('.theme__header');
  const observer = new ResizeObserver(() => {
    updateStickyFilter();
  });

  if (header) {
    observer.observe(header);
  }

  function updateStickyFilter() {
    const headerHeight = header.offsetHeight;
    const headerTop = header.offsetTop;
    const headerBottom = headerTop + headerHeight - 2;

    document.documentElement.style.setProperty('--header-bottom', headerBottom + 'px');
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
